import { render, staticRenderFns } from "./rule-form.vue?vue&type=template&id=678529d7&scoped=true"
import script from "./rule-form.vue?vue&type=script&setup=true&lang=js"
export * from "./rule-form.vue?vue&type=script&setup=true&lang=js"
import style0 from "./rule-form.vue?vue&type=style&index=0&id=678529d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678529d7",
  null
  
)

export default component.exports